import {SchemaProps} from "./JsonLdSchemaRouter";
import {PageGrid} from "../../../../../packages/graphql-layer/src";
import {trimTreeText} from "../../../../utility/componentUtil";

interface FaqItem {
    "@type": string;
    name: string;
    acceptedAnswer: {
        "@type": string;
        text: string;
    };
}

export function getFaqSchema(props: SchemaProps) {
    const pageGrid = (props.page as any)?.grid as PageGrid;
    if (!pageGrid || !pageGrid.placements) return null;

    const faqItems: FaqItem[] = [];

    function getFaqItem(item: any): FaqItem {
        const q = item.title || item.teaserTitle || "";
        const richText = (item.detailText || item.teaserText) as { textAsTree?: any } | undefined;
        const a = richText?.textAsTree ? trimTreeText(richText?.textAsTree) : "";

        return {
            "@type": "Question",
            "name": q,
            "acceptedAnswer": {
                "@type": "Answer",
                "text": a
            }
        };
    }

    pageGrid.placements.forEach((placement) => {
        if (!placement || !placement.items) return;
        placement.items.forEach((item: any) => {
            if (!item) return;
            if (item.type === "CMCollection" && item.viewtype === "c001_accordion") {
                const collectionItems = (item.items?.map((colItem: any) => getFaqItem(colItem)) || []) as FaqItem[];
                if (collectionItems.length > 0) {
                    faqItems.push(...collectionItems);
                }
            }
        });
    });

    if (faqItems.length === 0) {
        return null;
    }

    return {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": faqItems
    };
}
